'use client';
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '@/components/Footer';
import InteractiveHistorySection from '@/components/InteractiveHistorySection';
import OrganizationStatus from '@/components/OrganizationStatus';
import Image from 'next/image';
import ScrollTopButton from '@/components/ScrollTopButton';
export default function page() {
  const [isVisible, setIsVisible] = useState(false);
  const [sectionVisible, setSectionVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSectionVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="font-sans min-h-screen">
      <Header />
      <ScrollTopButton />
      <section className="pt-32 pb-20 lg:pt-40 lg:pb-24">
        <div className="px-4 sm:px-6 lg:px-44">
          {/* 장식 요소 */}
          <div
            className={`flex items-center gap-4 mb-6 transition-all duration-700 ${
              isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 -translate-y-4'
            }`}
          >
            <div className="w-20 h-1 bg-blue-600"></div>
            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
              About Us
            </span>
          </div>

          {/* 메인 제목 */}
          <h2
            className={`text-5xl md:text-7xl font-black text-gray-800 mb-6 transition-all duration-700 delay-150 ${
              isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 -translate-y-4'
            }`}
          >
            Company
          </h2>

          {/* 설명 텍스트 */}
          <p
            className={`text-base md:text-xl text-gray-600 max-w-3xl leading-relaxed transition-all duration-700 delay-300 ${
              isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 -translate-y-4'
            }`}
          >
            첨단 드론 기술과 인공지능의 융합으로 미래를 선도하는 KDdarts.
            <br />
            차별화된 기술력과 끊임없는 혁신으로 대한민국을 대표하는 K방산 드론
            전문기업으로 성장하고 <br />
            있습니다.
          </p>
        </div>
      </section>

      <main className="flex flex-col">
        <section className="relative px-4 pt-24 pb-20 mx-auto h-screen  sm:px-6 lg:px-8 lg:pt-40 overflow-hidden bg-[url('/images/bg1.png')] bg-cover bg-center bg-no-repeat">
          <div className="absolute inset-0 bg-gray-900/30"></div>
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-1/4 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
            <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-gray-500 rounded-full filter blur-3xl"></div>
          </div>

          <div className="relative lg:px-36">
            {/* 전체 너비 사용 */}
            <div
              className={`w-full transition-all duration-1000 ${
                sectionVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10'
              }`}
            >
              {/* Welcome 타이틀 */}
              <div className="mb-6">
                <span className="text-blue-600 text-sm md:text-base font-semibold italic tracking-wide">
                  Welcome to the Visitor
                </span>
              </div>

              {/* 메인 헤딩 */}
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-100 mb-8 lg:mb-12 leading-tight">
                케이디다츠에 많은 관심을 가져주신
                <br />
                고객님들께 진심으로 감사드립니다.
              </h2>

              {/* 본문 - 2단 레이아웃 */}
              <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-8 lg:mb-12">
                <div className="space-y-4">
                  <p className="text-sm md:text-base text-gray-100 leading-relaxed">
                    ㈜케이디다츠는 물체 탐지·추적 및 인공지능(AI) 기술, 그리고
                    항공기 시스템 분야의 융합 기술력을 기반으로 무인 항공기를
                    개발하는 전문 기업입니다.
                  </p>
                  <p className="text-sm md:text-base text-gray-100 leading-relaxed">
                    우리는 로봇 제어, 컴퓨터 비전, 실시간 임베디드 시스템 등
                    무인 항공 시스템의 핵심 기술을 독자적으로 확보하고 있습니다.
                    특히 복잡한 환경에서도 안정적인 비행을 가능하게 하는 정밀
                    비행 제어 알고리즘과, 실시간으로 주변 환경을 인식하고 스스로
                    판단하여 임무를 수행하는 자율 지능형 시스템을 구현하고
                    있습니다. 이러한 기술력은 수년간의 연구개발과 실전 경험을
                    통해 검증되었으며, 국내외 다양한 환경과 조건에서 우수한
                    성능을 입증해왔습니다.
                  </p>
                </div>

                <div className="space-y-4">
                  <p className="text-sm md:text-base text-gray-100 leading-relaxed">
                    끊임없는 연구개발과 혁신을 통해 자율 비행, 목표 인식, 환경
                    적응형 기동 등 첨단 기술이 결합된 무인 항공 시스템을
                    선보이며, 국방·산업·재난 대응 등 다양한 분야에서 활용 가능한
                    지능형 드론 플랫폼을 제공합니다.
                  </p>
                  <p className="text-sm md:text-base text-gray-100 leading-relaxed">
                    앞으로도 ㈜케이디다츠는 AI와 항공 기술의 융합을 선도하는
                    대한민국 대표 강소기업으로서, 더 안전하고 효율적이며
                    지능적인 미래 항공 생태계를 만들어가겠습니다. 우리는 기술의
                    경계를 넘어 새로운 가능성을 탐구하며, 고객과 사회에 실질적인
                    가치를 제공하는 혁신적인 솔루션을 지속적으로 개발할
                    것입니다. 더 나은 내일을 위한 기술 혁신, ㈜케이디다츠가 함께
                    만들어갑니다.
                  </p>
                </div>
              </div>

              {/* 서명 영역 */}
              <div className="flex items-end gap-4">
                <div className="flex flex-col">
                  <span className="text-base lg:text-lg font-bold text-gray-100">
                    (주) 케이디다츠 대표
                  </span>
                  <span className="text-xl lg:text-2xl font-black text-gray-100 mt-1">
                    김세영
                  </span>
                </div>
                <div className="relative mb-2">
                  <Image
                    src={'/images/ceoSign.png'}
                    alt={'대표님 서명'}
                    width={100}
                    height={60}
                    className="opacity-70"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <InteractiveHistorySection />

        <OrganizationStatus />
      </main>

      <Footer />
    </div>
  );
}
